export default __webpack_public_path__ + "static/media/banner04.2116bbd4.jpg";